export function excludeObjectFromValue(selected = [], data = {}) {
  const entries = Object.entries(data);

  return entries.reduce((filtered, [key, values]) => {
    const filteredValues = values.filter((option) => !selected.includes(option.wkzNumber || option));

    if (filteredValues.length > 0) {
      filtered[key] = filteredValues;
    }

    return filtered;
  }, {});
}

export function bodyTypesWithPlants(selectedPlants, typeVersions) {
  const plantsIds = selectedPlants.map(({ wkzNumber }) => wkzNumber);

  return excludeObjectFromValue(plantsIds, typeVersions);
}

export function filterObject(selectedIds = [], data = {}) {
  const allIds = Object.keys(data);
  const filteredPlants = allIds.reduce((plants, id) => {
    if (selectedIds.includes(id)) {
      return { ...plants, [id]: data[id] };
    }

    return plants;
  }, {});

  return filteredPlants;
}

export const getTypeVersions = (bodyTypesIds = [], plantsByBodyTypes = {}) => filterObject(bodyTypesIds, plantsByBodyTypes);

export function removeKey(keys = {}, id) {
  return Object.keys(keys).reduce((filtered, key) => {
    if (key === id) {
      return filtered;
    }

    return { ...filtered, [key]: keys[key] };
  }, {});
}

export const removeTypeVersion = (typeVersions = {}, id) => removeKey(typeVersions, id);
